import { render, staticRenderFns } from "./TourComponent.vue?vue&type=template&id=aab6695a"
import script from "./TourComponent.vue?vue&type=script&lang=js"
export * from "./TourComponent.vue?vue&type=script&lang=js"
import style0 from "./TourComponent.vue?vue&type=style&index=0&id=aab6695a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports